module.exports = __webpack_public_path__ + "img/card-offer-cayenne-pepper.97f66790.png";